import { Messages } from '~src/codegen/Localize';

import { BaasEdgePoolErrorCode } from '../types/BaasEdgePoolError';
import { BaasEdgePoolErrorContext } from '../types/BaasEdgePoolErrorContext';

export function getGeneralErrorMessage(errorCode: number, message: string) {
  let errorMessage: string = null;
  switch (errorCode) {
    case 17:
      errorMessage = message;
      break;
  }

  return errorMessage ? errorMessage : Messages.dataConnectSiteSettingsErrorInternal();
}

export function getErrorMessage(errorCode: BaasEdgePoolErrorCode, context: BaasEdgePoolErrorContext) {
  let errorMessage: string = null;
  switch (errorCode) {
    case BaasEdgePoolErrorCode.POOL_ID_DOES_NOT_EXIST:
      errorMessage = getErrorMessageForCreatePool(context);
      break;
    case BaasEdgePoolErrorCode.PARTIAL_DELETION:
      errorMessage = getErrorMessageForDeletePools(context);
      break;
    case BaasEdgePoolErrorCode.INVALID_CHANGE_TYPE:
      errorMessage = getErrorMessageForUpdatePool(context);
      break;
  }

  return errorMessage ? errorMessage : Messages.dataConnectSiteSettingsErrorInternal();
}

function getErrorMessageForCreatePool(context: BaasEdgePoolErrorContext) {
  if (context.poolName) {
    return Messages.dataConnectSiteSettingsErrorCreatePool({ POOL_NAME: context.poolName });
  }
  return null;
}

function getErrorMessageForDeletePools(context: BaasEdgePoolErrorContext) {
  if (context.poolName) {
    return Messages.dataConnectSiteSettingsErrorPartialDeletion({ POOL_NAME: context.poolName });
  }
  return null;
}

function getErrorMessageForUpdatePool(context: BaasEdgePoolErrorContext) {
  if (context.poolName && !context.domainName && !context.nodeName) {
    return Messages.dataConnectSiteSettingsErrorUpdatePool({ POOL_NAME: context.poolName });
  }
  if (!context.poolName && context.domainName && !context.nodeName) {
    return Messages.dataConnectSiteSettingsErrorUpdateDomain({ DOMAIN_NAME: context.domainName });
  }

  return null;
}
